const secToMin = (seconds:number) => {
  const count = Math.floor(seconds)
  const restSeconds = count % 60;
  const totalMin = (count - restSeconds) / 60;

  return `${totalMin}:${restSeconds < 10 ? '0' + restSeconds : restSeconds}`;
}

export default secToMin;